import { connect } from 'react-redux';

import UserManagementView from './UserManagementView.jsx';

import { showSettingsSideMenu, hideSettingsSideMenu }
  from 'src/legacy/redux/actions/settings.jsx';

import { fetchUserManagementList, fetchAccountUsers, inviteUser, invalidateErrorMessage, selectUser, invalidateUser, 
         updateUserActivation, updateUserAccess, resendInvitation, 
         deleteInvitation, intializeDownloadReport} from 'src/legacy/redux/actions/userManagement.jsx';

import { fetchUserRolesForAccount } from 'src/legacy/redux/actions/userRoles';
import { fetchUserGroup } from 'src/legacy/redux/actions/userGroups';
import hasAccess from 'src/legacy/services/hasAccess.jsx';
import _ from 'lodash';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';
import { invalidateUserSelection } from 'src/legacy/redux/actions/selection';
import {trackAdoptionMetricsForCreateUserGroupClickedevent} from "src/legacy/redux/actions/adoption";
import { fetchActiveUsersCountForAccount } from 'src/redux/actions/users';

const mapStateToProps = (state, ownProps) => {
  return {
    loading: _.get(state.legacyRootReducer, "settings.userManagement.loading"),
    loadMore: _.get(state.legacyRootReducer, "settings.userManagement.loadMore"),
    showSettingsMenu: _.get(state.legacyRootReducer, "settings.settingsMenu.showSettingsMenu"),
    errorMessage: _.get(state.legacyRootReducer, "settings.userManagement.inviteError"),
    inviting: _.get(state.legacyRootReducer, "settings.userManagement.inviting"),
    deleting: _.get(state.legacyRootReducer, "settings.userManagement.deleting"),
    updating: _.get(state.legacyRootReducer, "settings.userManagement.users.updating"),
    showManageRoles: _.get(state, "accounts.item.manageRoles")
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showSettingsSideMenu: () => {
       dispatch(showSettingsSideMenu());
    },
    fetchUserManagementList: (page, query, filter) => {
      dispatch(fetchUserManagementList(page, query, filter))
    },
    downloadReport: (id, request, page, limit) => {
      return dispatch(intializeDownloadReport(id, request, page, limit));
    },
    fetchAccountUsers: (page, query, filter) => {
      dispatch(fetchAccountUsers(page, query, filter))
    },
    hideSettingsSideMenu: () => {
        dispatch(hideSettingsSideMenu())
    },
    inviteUser: (user) => {
        return dispatch(inviteUser(user))
    },

    invalidateErrorMessage: () => {
        dispatch(invalidateErrorMessage())
    },

    selectUser: (user) => {
       return dispatch(selectUser(user))
    },

    updateUserActivation: (user) => {
       dispatch(updateUserActivation(user))
    },

    updateUserAccess: (user) => {
      dispatch(updateUserAccess(user))
    },

    resendInvitation: (id) => {
      dispatch(resendInvitation(id))
    },

    deleteInvitation: (id) => {
      return dispatch(deleteInvitation(id));
    },

    fetchUserRolesForAccount: () => {
      return dispatch(fetchUserRolesForAccount());
    },
    fetchUserGroup: (id) => {
      return dispatch(fetchUserGroup(id));
    },
    invalidateUserSelection:() => {
      return dispatch(invalidateUserSelection());
    },
    fetchActiveUsersCountForAccount:() => {
      return dispatch(fetchActiveUsersCountForAccount());
    },
    trackAdoptionMetricsForCreateUserGroupClickedevent: () => {
      return dispatch(trackAdoptionMetricsForCreateUserGroupClickedevent());
    }
  }
}

const UserManagementPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(UserManagementView);

// export default hasAccess(UserManagementPage, 'user-management');

export default withUseHooks(UserManagementPage);